import React from 'react'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import AddClassForm from "../components/AddClassForm/AddClassForm"
import { Container } from "react-bootstrap"
import { useSelector } from 'react-redux'

function AddClass() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <Container>
        <div className="d-flex flex-column w-100">
          <AuthNavbar />
          <div className="mt-5 mx-3">
            <HomeTitle title={currentLocal.home.addclass} />

            <AddClassForm />
          </div>

        </div>
      </Container>
    </div>
  )
}

export default AddClass
